import styled from 'styled-components'

const Spacer = styled.div`
    flex-grow:4;
`

export default Spacer;